import { IsOptional, IsArray, IsNumber, ValidateNested } from "class-validator";
import { Type } from "class-transformer";

import { IQuery } from "./query.interface";
import { QueryAttributeSortDto } from "./query-attribute-sort.dto";
import { QueryAttributeGroupDto } from "./query-attribute-group.dto";

export class QueryDto implements IQuery {
  @IsOptional()
  @IsNumber()
  $skip?: number;

  @IsOptional()
  @IsNumber()
  $limit?: number;

  @IsOptional()
  @ValidateNested()
  @Type(() => QueryAttributeGroupDto)
  query?: QueryAttributeGroupDto;

  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => QueryAttributeSortDto)
  sort?: QueryAttributeSortDto[];

  @IsOptional()
  @IsArray()
  $pipeline?: any[];
}
